<template>
  <div class="app-restricted-login-wrapper">
    <slot name="txtBefore"></slot>
    <InputMsisdn v-if="isQueryMsisdn" :nextStep="inputChannelStepName">
      <template v-for="slot in possibleChildSlotsFor('InputMsisdn')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </InputMsisdn>
    <InputChannel v-if="isQueryChannel" :previousStep="inputMsisdnStepName" :nextStep="inputTokenStepName">
      <template v-for="slot in possibleChildSlotsFor('InputChannel')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </InputChannel>
    <InputToken v-if="isQueryToken" :previousStep="inputChannelStepName">
      <template v-for="slot in possibleChildSlotsFor('InputToken')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </InputToken>
    <div v-if="isLoggedIn"></div>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { onLogout as apolloLogout } from '@/apollo'
import { PERSISTENCE_KEY } from '@/store/config'
import { mapActions, mapGetters } from 'vuex'
import InputMsisdn, { stepName as inputMsisdnStepName } from '@/components/process/generic/Authentication/Login/RestrictedLogin/InputMsisdn.vue'
import InputChannel, { stepName as inputChannelStepName } from '@/components/process/generic/Authentication/Login/RestrictedLogin/InputChannel.vue'
import InputToken, { stepName as inputTokenStepName } from '@/components/process/generic/Authentication/Login/RestrictedLogin/InputTokenDateSelect.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'RestrictedLogInWrapper',
  components: { InputChannel, InputMsisdn, InputToken },
  mixins: [
    transaction('Auth'),
    slotProxy()
  ],
  import: {
    inputMsisdnStepName,
    inputChannelStepName,
    inputTokenStepName
  },
  computed: {
    isQueryMsisdn () {
      return this.currentStep === inputMsisdnStepName
    },
    isQueryChannel () {
      return this.currentStep === inputChannelStepName
    },
    isQueryToken () {
      return this.currentStep === inputTokenStepName
    },
    isLoggedIn () {
      return this.currentStep === 'loggedIn'
    },
    ...mapGetters({
      currentStep: 'currentRestrictedLoginStep'
    })
  },
  methods: {
    checkContaoLogin () {
      const portalLoginForm = document.querySelector('form.mod_login')
      if (portalLoginForm) {
        return portalLoginForm.classList.contains('logout')
      }
      return null
    },
    logoutContao () {
      const portalLoginForm = document.querySelector('form.mod_login')
      if (portalLoginForm) {
        if (portalLoginForm.classList.contains('logout')) {
          window.location = portalLoginForm.action
        }
      }
    },
    ...mapActions(['logout'])
  },
  async beforeMount () {
    if (this.isLoggedIn) {
      await this.logout()
      sessionStorage.removeItem(PERSISTENCE_KEY)
      apolloLogout(this.$apolloProvider.defaultClient)
    }
    if (this.checkContaoLogin()) {
      this.logoutContao()
    }
  }
}
</script>
